export const LOAD_SIMILAR_SOLD_ITEMS_V3_FAIL = 'LOAD_SIMILAR_SOLD_ITEMS_V3_FAIL';
export const LOAD_SIMILAR_SOLD_ITEMS_V3_REQUEST = 'LOAD_SIMILAR_SOLD_ITEMS_V3_REQUEST';
export const LOAD_SIMILAR_SOLD_ITEMS_V3_SUCCESS = 'LOAD_SIMILAR_SOLD_ITEMS_V3_SUCCESS';
